import { useTranslation } from "react-i18next"

import { Button } from "@/globalComponents/atoms/Button"
import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"
import Modal from "@/globalComponents/molecules/Modal"

import styles from "./reservationModals.module.css"

interface Props {
  isOpen: boolean
  onOpenChange: () => void
  plate: string
  onConfirm: () => void
}

export function ConfirmVehicleModal({
  isOpen,
  onOpenChange,
  plate,
  onConfirm,
}: Props) {
  const { t } = useTranslation("reserve")

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Header>
        <Heading level={2} slot="title">
          {t("confirmation.confirmYourPlate")}
        </Heading>
      </Modal.Header>

      <Modal.Body className={styles.confirmBody}>
        <Text level={2} className="semi-bold">{t("confirmation.youAdded")}</Text>
        <div className={styles.plateDisplay}>{plate}</div>
        <Text level={2}>{t("confirmation.doubleCheckPlate")}</Text>
      </Modal.Body>

      <Modal.Footer arrangement="horizontal">
        {() => (
          <>
            <Button buttonType="default" onPress={onOpenChange}>
              {t("confirmation.back")}
            </Button>
            <Button buttonType="primary" onPress={onConfirm}>
              {t("confirmation.confirm")}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  )
}
